export default __webpack_public_path__ + "static/media/portfolio_desktop.1b9afacc.png";